import { useRef, useState } from "react";
import { CommentAPI } from "@griffingroupglobal/eslib-api";
import useOutsideAlerter from "../../../../hooks/useOutsideAlerter";
import { useAppState } from "../../../../state/appState";

const useRejectTimesheetData = ({ popupData, closePopup }) => {
  const [{ currentUser }] = useAppState();
  const [denyMessage, setDenyMessage] = useState("");
  const popupRef = useRef(null);

  useOutsideAlerter(popupRef, () => closePopup());

  const popUpContainerStyles = {
    width: popupData?.popupWidth ?? 239,
    maxHeight: 500,
    overflow: "scroll",
  };

  const handleDenyTimesheet = (cb) => {
    const timesheetReference = popupData?.timesheet?.reference;
    const tempObj = {
      content: denyMessage || "Cannot be approved, see supervisor",
      association: timesheetReference,
      author: currentUser?.reference,
    };

    closePopup();

    /* NERD: there is no race condition to worry about so we cant use fire and forget js
     *   to make it seems like its happening in the background */
    (async () => {
      try {
        await Promise.all([
          CommentAPI.post(tempObj),
          popupData?.updateTimesheet(),
        ]);
      } catch (error) {
        console.error("Failed to post comment", error);
        cb("Failed to post comment");
      }
    })();
  };

  return {
    popupRef,
    popUpContainerStyles,
    denyMessage,
    setDenyMessage,
    handleDenyTimesheet,
  };
};

export default useRejectTimesheetData;
